/* BASIQ · Pestañas de ejercicios: cambia de panel y pausa los vídeos que se ocultan */
(function () {
  function setup(root) {
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    function select(i, focus) {
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focus) t.focus();
      });
      panels.forEach(function (p, n) {
        var on = n === i;
        p.classList.toggle('is-active', on);
        if (on) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
          p.querySelectorAll('video').forEach(function (v) { v.pause(); });
        }
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        if (next !== null) { e.preventDefault(); select(next, true); }
      });
    });

    /* En el editor: al seleccionar un bloque, abre su pestaña */
    root.addEventListener('shopify:block:select', function (e) {
      var idx = panels.indexOf(e.target.closest('[role="tabpanel"]'));
      if (idx > -1) select(idx, false);
    });
  }

  function initAll(r) {
    (r || document).querySelectorAll('[data-bp-tabs]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
